<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <div :class="b()">
    <div :class="b('content')">
      <p :class="b('title')">
        {{ $t("Обмен") }} {{ row.currency_from.name.toUpperCase() }} →
        {{ row.currency_to.name.toUpperCase() }}
      </p>
      <p :class="b('meta')">
        {{ row.created_at }} · {{ displayedAmountFrom }}
        {{ row.currency_from.name.toUpperCase() }}
      </p>
    </div>

    <span :class="b('status', { [statusTone]: true })">
      <i></i>{{ $t(statusLabel) }}
    </span>
  </div>
</template>
